import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  productSubstitutionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  productSubstitutionsContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    padding: '24px',
    gap: '24px',
  },
  productsAndDeliveryTitle: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    fontStyle: 'normal',
  },
  productsAndDeliveryContentBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    gap: '24px',
  },
  productSubstitutionsButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    padding: '16px 24px',
    gap: '15px',
    '@media (min-width: 834px)': {
      flexDirection: 'row',
    },
  },
  cancelButtonClass: {
    padding: '10px 16px',
    borderColor: theme.evPalette.salt[100],
    width: '100%',
    '@media (min-width: 834px)': {
      width: 'auto',
    },
  },
  saveButtonClass: {
    padding: '10px 16px',
    width: '100%',
    '@media (min-width: 834px)': {
      width: 'auto',
    },
  },
}));
